import { NavLink } from 'react-router-dom';
import { hapticSelection } from '../../lib/haptics';
import {
  LayoutDashboard,
  Moon,
  Library,
  MessagesSquare,
  Wallet,
} from 'lucide-react';

// Onglets principaux de la barre de navigation basse (mobile uniquement).
// La Médiathèque est un module central pour les membres : elle figure ici en
// accès direct. Le menu secondaire (« Plus ») a été déplacé dans l'en-tête
// mobile (bouton menu), ce qui libère un emplacement sans surcharger la barre.
const TABS = [
  { to: '/dashboard', icon: LayoutDashboard, label: 'Accueil', end: true },
  { to: '/dashboard/spiritualite', icon: Moon, label: 'Spiritualité' },
  { to: '/dashboard/mediatheque', icon: Library, label: 'Médiathèque' },
  { to: '/dashboard/communaute', icon: MessagesSquare, label: 'Communauté' },
  { to: '/dashboard/finances', icon: Wallet, label: 'Cotisations' },
];

export const MobileTabBar = () => {
  return (
    /* Barre d'onglets — visible uniquement sur mobile (md:hidden). */
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden border-t border-border/60 bg-background/80 backdrop-blur-xl safe-bottom shadow-[0_-4px_20px_rgba(0,0,0,0.06)]"
      aria-label="Navigation principale"
    >
      <div className="grid grid-cols-5 h-16">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            onClick={() => hapticSelection()}
            className={({ isActive }) =>
              `relative flex flex-col items-center justify-center gap-0.5 px-0.5 text-[10px] font-medium transition-colors ${
                isActive ? 'text-primary' : 'text-muted-foreground'
              }`
            }
          >
            {({ isActive }) => (
              <>
                {/* Indicateur actif animé en haut de l'onglet */}
                <span
                  className={`absolute top-0 h-1 w-8 rounded-b-full bg-primary transition-all duration-300 ${
                    isActive ? 'opacity-100 scale-100' : 'opacity-0 scale-0'
                  }`}
                />
                <tab.icon
                  className={`h-[22px] w-[22px] transition-transform duration-200 ${
                    isActive ? '-translate-y-0.5 scale-110' : ''
                  }`}
                />
                <span className="max-w-full truncate">{tab.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
